import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

/**
 * @param {{ phone?: string, email?: string, otp: string }} payload
 */
const authManager = async (id, payload) => {
  const response = await axios.post(
    routes.inviteflowAuth(id),
    payload,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default authManager;
